import service from '../services/request'

// 获取签名
export const getConfig = function (data) {
  return service({
    method: 'post',
    url: '/weixin/getConfig',
    data
  })
}

// 获取省市县的列表
export const getAreaJSON = () => {
  return service({
    method: 'get',
    url: '/baseaddress/getAllCodes',
  })  
}

// 获取数据类型 0：问卷类目；1：社会身份；2：问题类型
export const getType = function (params) {
  return service({
    method: 'get',
    url: '/common/getTypes',
    params
  })
}

export const queryTquestion = function (params) {
  return service({
    method: 'get',
    url: '/user/queryTquestion',
    params
  })
}
export const getImage = function (params) {
  return service({
    method: 'get',
    url: '/answer/getImage',
    params
  })
}

// 答卷时删除上传的文件
export const deleteUploadFile = function (params) {
  return service({
    method: 'post',
    url: '/answer/delfile',
    params
  })
}
